<div class="hero-section">
  <div class="hero-content">

    <div class="hero-brand">
      <img src="icon.svg" alt="Radical Events" class="hero-icon">
    </div>

    <h1 class="main-title">
      <span class="text-gradient">AGENDA RADICAL</span>
    </h1>

    <p class="hero-subtitle">Sua próxima aventura começa aqui.</p>

    <div class="search-container glass-panel">
      <form [formGroup]="searchForm" (ngSubmit)="onSearch()" class="search-form">

        <mat-form-field appearance="outline" class="search-field">
          <mat-label>O que você procura?</mat-label>
          <input matInput formControlName="query">
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Onde?</mat-label>
          <input matInput formControlName="location">
          <mat-icon matPrefix>location_on</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Quando?</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="date">
          <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <button mat-raised-button class="search-button" type="submit">
          <mat-icon>search</mat-icon>
        </button>

      </form>
    </div>

    <div class="hero-cta">
      <button mat-raised-button color="primary" class="cta-button glow-on-hover" routerLink="/events">
        EXPLORAR EVENTOS
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>

    <!-- Filtro Rápido por Modalidades -->
    <div class="quick-categories reveal-on-scroll" style="animation-delay: 0.4s">
      <div class="category-item hover-lift" *ngFor="let cat of categories" (click)="filterByCategory(cat.description)">
        <div class="icon-circle">
          <mat-icon>{{ cat.icon }}</mat-icon>
        </div>
        <span>{{ cat.description }}</span>
      </div>
    </div>

    <!-- Seção de Eventos em Destaque -->
    <div class="featured-section reveal-on-scroll" style="animation-delay: 0.6s">
      <div class="section-header">
        <h2 class="text-gradient">Eventos em Destaque</h2>
        <button mat-button color="primary" routerLink="/events">VER TODOS <mat-icon>chevron_right</mat-icon></button>
      </div>

      <ng-container *ngIf="featuredEvents$ | async as events">
        <div class="events-grid" *ngIf="events.length > 0; else emptyEvents">
          <article class="event-card hover-lift" *ngFor="let event of events.slice(0, 3)">
            <!-- A imagem carrega só o chip de modalidade: nada de texto do evento sobre
                 o banner enviado pelo organizador. -->
            <div class="card-media">
              <img *ngIf="event.bannerImage" [src]="event.bannerImage" [alt]="event.title" class="card-media__image">
              <div class="card-media__placeholder" *ngIf="!event.bannerImage">
                <mat-icon>photo_camera</mat-icon>
              </div>
              <span class="card-media__category">{{ event.category.description }}</span>
            </div>

            <div class="card-body">
              <div class="card-headline">
                <div class="event-date" [attr.aria-label]="'Data do evento: ' + (event.date | brDate)">
                  <span class="event-date__day">{{ getEventDay(event) }}</span>
                  <span class="event-date__month">{{ getEventMonth(event) }}</span>
                </div>

                <div class="card-headline__text">
                  <h3 class="event-title" [title]="event.title">{{ event.title }}</h3>
                  <p class="event-location">
                    <mat-icon>location_on</mat-icon>
                    <span>{{ event.location }}</span>
                  </p>
                </div>
              </div>

              <div class="event-price">
                <ng-container *ngIf="!isRegistrationClosed(event); else inscricoesEncerradas">
                  <ng-container *ngIf="event.price; else gratuito">
                    <span class="event-price__label">A partir de</span>
                    <span class="event-price__value">{{ event.price | currency:'BRL' }}</span>
                  </ng-container>
                  <ng-template #gratuito>
                    <span class="event-price__value">Gratuito</span>
                  </ng-template>
                </ng-container>
                <ng-template #inscricoesEncerradas>
                  <span class="event-price__closed">Inscrições encerradas</span>
                </ng-template>
              </div>

              <div class="card-actions">
                <button mat-stroked-button color="primary" [routerLink]="['/events', eventPath(event)]">DETALHES</button>
                <button mat-raised-button color="accent" class="glow-on-hover" [disabled]="isRegistrationDisabled(event)"
                (click)="subscribeToEvent(event)">{{ getRegistrationButtonText(event) }}</button>
              </div>
            </div>
          </article>
        </div>

        <ng-template #emptyEvents>
          <div class="empty-events">
            <mat-icon class="empty-icon">event_busy</mat-icon>
            <h3>Nenhum evento em destaque no momento</h3>
            <p>Novos eventos radicais estão a caminho. Fique ligado!</p>
            <button mat-stroked-button color="primary" routerLink="/events">VER TODOS OS EVENTOS</button>
          </div>
        </ng-template>
      </ng-container>
    </div>

    <!-- Parceiros Oficiais -->
    <div class="sponsors-section reveal-on-scroll" style="animation-delay: 0.8s" *ngIf="sponsors.length > 0">
      <div class="sponsors-header">
        <div class="sponsors-divider"></div>
        <h3 class="sponsors-title">Parceiros Oficiais</h3>
        <div class="sponsors-divider"></div>
      </div>

      <div class="sponsors-ticker">
        <div class="sponsors-track">
          <a *ngFor="let sponsor of sponsors"
             class="sponsor-item"
             [href]="sponsorLink(sponsor)"
             target="_blank"
             rel="noopener noreferrer">
            <div class="sponsor-logo-wrapper">
              <img *ngIf="sponsor.logo"
                   [src]="sponsor.logo"
                   [alt]="sponsor.name">
              <mat-icon *ngIf="!sponsor.logo">business</mat-icon>
            </div>
            <span class="sponsor-name">{{ sponsor.name }}</span>
          </a>
          <!-- Duplicado para loop infinito -->
          <a *ngFor="let sponsor of sponsors"
             class="sponsor-item"
             [href]="sponsorLink(sponsor)"
             target="_blank"
             rel="noopener noreferrer">
            <div class="sponsor-logo-wrapper">
              <img *ngIf="sponsor.logo"
                   [src]="sponsor.logo"
                   [alt]="sponsor.name">
              <mat-icon *ngIf="!sponsor.logo">business</mat-icon>
            </div>
            <span class="sponsor-name">{{ sponsor.name }}</span>
          </a>
        </div>
      </div>
    </div>

  </div>
</div>
